import {
  Component,
  OnInit,
  ViewChild,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatGridListModule } from '@angular/material/grid-list'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete'
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { Product } from '../../types/products'
import { Observable, switchMap, map, debounceTime } from 'rxjs'
import { AsyncPipe } from '@angular/common'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { ProductService } from '../../services/product.service'
import { TranslationService } from '../../services/translation.service'
@Component({
  selector: 'app-product-search',
  imports: [
    MatToolbarModule,
    MatGridListModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    AsyncPipe,
    CommonModule,
  ],
  templateUrl: './product-search.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-search.component.scss',
})
export class ProductSearchComponent implements OnInit {
  private router = inject(Router)
  private productService = inject(ProductService)
  translationService = inject(TranslationService)

  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger

  searchControl = new FormControl<string | Product>('')
  filteredOptions: Observable<Array<Product>> | undefined

  ngOnInit() {
    this.filteredOptions = this.searchControl.valueChanges.pipe(
      debounceTime(300),
      map((value: string | Product | null) => {
        const name = typeof value === 'string' ? value : value?.name
        return name == null ? '' : name
      }),
      switchMap((value: string) => {
        return this.productService.autoCompleteProducts({
          name: value,
        })
      }),
    )
  }

  /**
   * Handles product select event
   * @param {MatAutocompleteSelectedEvent} event  Product selection event
   */
  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    const id = event.option.value
    this.router.navigate([`/products/${id}/overview`])
  }

  /**
   * Displays the name of a product
   * @param {Product} product Product to display
   * @returns {string} Product name
   */
  displayName(product: Product): string {
    return product && product.name ? product.name : ''
  }

  /**
   * Goes to the product search page and filters by what is in the autocomplete input
   */
  gotoSearchPage() {
    const name = this.searchControl.value
    this.autocomplete.closePanel()
    this.router.navigate([`/products`], { queryParams: { name } })
  }
}
